import { CSSProperties, useState } from 'react'
import { CardMedia } from '@iziplay/ui-kit'

export function AlbumCover({
  src,
  animatedSrc,
  animate,
  title,
  style
}: {
  src: string
  animatedSrc?: string
  animate?: boolean
  title: string
  style?: CSSProperties
}) {
  const [failed, setFailed] = useState(false)

  if (animatedSrc && animate) {
    return (
      <video
        className="ui-card__media"
        src={animatedSrc}
        poster={failed ? undefined : src}
        autoPlay
        loop
        muted
        playsInline
        style={{ aspectRatio: '1 / 1', ...style }}
      />
    )
  }

  if (failed) {
    return (
      <CardMedia
        style={{
          aspectRatio: '1 / 1',
          backgroundColor: 'var(--black)',
          backgroundImage: "url('/img/white-50.png')",
          // Zoomed past recognition: an abstract crop, like the movie
          // card fallback where cover on a 2:3 poster crops the logo.
          backgroundSize: '160%',
          backgroundPosition: 'center',
          ...style
        }}
        title={title}
      />
    )
  }

  return (
    <CardMedia
      component="img"
      image={src}
      alt={title}
      style={{ aspectRatio: '1 / 1', ...style }}
      onError={() => setFailed(true)}
    />
  )
}
